import type { Immutable } from "immer";
import React from "react";
import { getGlobalSpacingClasses } from "tsi-common-react/src/components/_spacing/globalSpacing";

import type { MattressDifferenceBlock as MattressDifferenceBlockValue } from "@reactivated";
import type { ImageChooserBlock } from "@reactivated";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import { richHTML } from "../../utils/html";

import styles from "./index.module.scss";

const getImageAlt = (
    image: Immutable<ImageChooserBlock> | null | undefined,
): string => image?.default_alt_text || image?.title || "";

export const MattressDifferenceBlock = (
    block: Immutable<{ value: MattressDifferenceBlockValue }>,
): React.JSX.Element => (
    <section
        className={concatClassNames([
            styles.mattressDifferenceBlock,
            block.value.background_style?.style ?? "",
            getGlobalSpacingClasses(block.value.spacing),
        ])}
    >
        <div className="main-container">
            <div
                className={styles.mattressDifferenceBlockTitle}
                dangerouslySetInnerHTML={richHTML(block.value.title)}
            />
            <div
                className={styles.mattressDifferenceBlockSubtitle}
                dangerouslySetInnerHTML={richHTML(block.value.subtitle)}
            />
            <div className={styles.mattressDifferenceBlockImage}>
                {block.value.image ? (
                    <img
                        src={block.value.image.url}
                        alt={getImageAlt(block.value.image)}
                        className="responsive"
                        loading="lazy"
                        decoding="async"
                    />
                ) : null}
            </div>
            <div className={styles.mattressDifferenceBlockSoftFirm}>
                <div className={styles.mattressDifferenceMattress}>
                    <h2 className={styles.mattressTitle}>
                        <span
                            className="mattress__title-color mattress__title-color--soft"
                            style={
                                block.value.soft_color
                                    ? {
                                          backgroundColor:
                                              block.value.soft_color,
                                      }
                                    : undefined
                            }
                            aria-hidden="true"
                        ></span>
                        <span
                            dangerouslySetInnerHTML={richHTML(
                                block.value.soft_title,
                            )}
                        />
                    </h2>
                    <div
                        className="mattress__copy"
                        dangerouslySetInnerHTML={richHTML(
                            block.value.soft_subtitle,
                        )}
                    />
                </div>
                <div className={styles.mattressDifferenceMattress}>
                    <h2 className={styles.mattressTitle}>
                        <span
                            className="mattress__title-color mattress__title-color--firm"
                            style={
                                block.value.firm_color
                                    ? {
                                          backgroundColor:
                                              block.value.firm_color,
                                      }
                                    : undefined
                            }
                            aria-hidden="true"
                        ></span>
                        <span
                            dangerouslySetInnerHTML={richHTML(
                                block.value.firm_title,
                            )}
                        />
                    </h2>
                    <div
                        className="mattress__copy"
                        dangerouslySetInnerHTML={richHTML(
                            block.value.firm_subtitle,
                        )}
                    />
                </div>
            </div>
        </div>
    </section>
);
